import { render, staticRenderFns } from "./VenueSettingsPage.vue?vue&type=template&id=fe61671a&scoped=true"
import script from "./VenueSettingsPage.vue?vue&type=script&lang=ts"
export * from "./VenueSettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./VenueSettingsPage.vue?vue&type=style&index=0&id=fe61671a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe61671a",
  null
  
)

export default component.exports